import { fetchGet, toQueryString } from "../api_client";

export const GetUserSessionLogs = async (option: {
  count?: number;
  page?: number;
  user_id?: string;
  user_name?: string;
  email?: string;
  event?: string;
  is_emp?: boolean;
  from?: string;
  to?: string;
}) => {
  try {
    const url = `${
      process.env.REACT_APP_BACKEND_BASE_URL
    }/api/v3/auth/session-logs${toQueryString(option)}`;

    const res = await fetchGet(url);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
